export default __webpack_public_path__ + "static/wafflebot-animated-c87192ceffae07a9ae39b49f8945a020.gif";